export async function set(key, value) {
    window.localStorage.setItem(`auth_flow.${key}`, value);
}
export async function get(key) {
    return window.localStorage.getItem(`auth_flow.${key}`);
}
export async function clear(key) {
    window.localStorage.removeItem(`auth_flow.${key}`);
}
